export enum UrlPathEnums {
  NlpSearch = '/nlp-search',
  IndexSearch = '/index-search',
  UsersBulkUploadAdd = '/users/bulkupload/add',
  UsersBulkUploadResults = '/users/bulkupload/results',
  UsersDetails = '/users/details',
  UsersAdd = '/users/add',
  UsersBulkUploadFileprocessing = '/users/bulkupload/fileprocessing',
  UploadFileCatalyst = '/upload-file-catalyst'
}
